import React from "react";
import "../Dashboard/Dashboard.css";
import { Image, Col, Row } from "react-bootstrap";
import TopCoupons from "../TopCoupons/TopCoupons";
import { useState } from "react";
import { useEffect } from "react";
import { CouponDashBoardAPI } from "../../Utils/Api/CouponsDashboardApi";
import { userId } from "../../Utils/LocalStorage";
import Loader from "../../Components/Loader/Loader";
import couponpic1 from "../../assets/cou-(1).svg";
import couponpic2 from "../../assets/cou-(2).svg";
import couponpic3 from "../../assets/cou-(3).svg";
import couponpic4 from "../../assets/cou-(4).svg";
import ManageCouponsCouponDashboard from "../ManageCoupons/ManageCouponsCouponDashboard";
import { Graph_C } from "./Graph_C";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Bu_id = userId();

const CouponsDashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [topSectiondata, setTopSectionData] = useState({});

  const [GraphData, setGraphData] = useState([]);
  const [GraphData1, setGraphData1] = useState([]);

  const navigate = useNavigate();

  const CouponsDashboardAPIHandler = async () => {
    const val = {
      user_id: Bu_id,
      start_date: "",
      end_date: "",
    };
    setLoading(true);
    const CouponsDashboardData = await CouponDashBoardAPI(val, () => {
      navigate("/");
    });
    if (CouponsDashboardData.status === 429) {
      toast.error(CouponsDashboardData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(true);
    } 
    setLoading(false);
    setData(CouponsDashboardData);
    setTopSectionData(CouponsDashboardData.top_section);
    setGraphData(CouponsDashboardData.downloaded_coupons_of_week);
    setGraphData1(CouponsDashboardData.redeemed_coupons_of_week);
  };

  useEffect(() => {
    CouponsDashboardAPIHandler();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <Row className="dashboard-card mt-4 pt-2 cop-dash">
        <Col md="6" lg="3" className="mb-2">
          <div className="card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={couponpic1} height="28px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Total Coupons</p>
              <p className="dash-text2">
                {topSectiondata ? topSectiondata.total_coupons : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="6" lg="3" className="mb-2">
          <div className="card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={couponpic2} height="28px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Active Coupons</p>
              <p className="dash-text2">
                {topSectiondata ? topSectiondata.active_coupons : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="6" lg="3" className="mb-2">
          <div className="card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={couponpic3} height="28px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">
                Coupons Downloaded
                {/* <br /> this month */}
              </p>
              <p className="dash-text2">
                {topSectiondata ? topSectiondata.new_coupons_of_this_month : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="6" lg="3" className="mb-2">
          <div className="card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={couponpic4} height="28px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Redeemed Coupons</p>
              <p className="dash-text2">
                {topSectiondata ? topSectiondata.total_redeemed : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
      </Row>

      {/* graph */}
      <Graph_C
        GraphData={GraphData}
        GraphData1={GraphData1}
        setGraphData1={setGraphData1}
        setGraphData={setGraphData}
        setLoading={setLoading}
        Bu_id={Bu_id}
      />

      <Row className="mt-4">
        <Col md="12">
          {/* <TopCoupons tableData={data} /> */}
          <ManageCouponsCouponDashboard />
        </Col>
      </Row>
    </>
  );
};

export default CouponsDashboard;
